export default {
    points: [
        { x: 1990, y: 16.7 },
        { x: 1995, y: 14.6 },
        { x: 2000, y: 14.4 },
        { x: 2007, y: 14 },
        { x: 2010, y: 13 },
        { x: 2015, y: 12.4 },
    ],
    yTicks: [0, 5, 10, 15, 20]
}